/**
 * @file 全局配置
 * @author hardylin <hardylin@tencent.com>
 */
export default {

    // 主题色
    colors: {
        1: '#1c1c1c',
        2: '#555555',
        3: '#aaaaaa',
        4: '#4c84ff',
        5: '#4c84ff',
        6: '#f2f2f2',
        7: '#ffffff',
        8: '#e1e1e1',
        9: '#ffffff',
        10: '#f2f2f2',
        11: '#fb4855',
        12: '#ff9f01',
        13: '#3ec16c',
        14: '#4c84ff',
        15: '#888888',
        16: '#ffffff',
        17: '#e0e0e0',
        18: '#f2f2f2',
        19: '#bbbbbb',
        20: '#1c1c1c'
    }
}